
import { Component, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { API_TTeammate } from "@/models/company_teammates";

import { SUCCESS_NOTIFICATION_TYPE, ERROR_NOTIFICATION_TYPE } from "@/constants/notification";
import { PERMISSION_TYPES, MEMBER_VALUE } from "@/constants/teammates";

import { someValueInFormIsEmpty } from "@/utils/methods";
import { CFormField } from "@/models/form_cards";
import { REs } from "@/utils/REs";

const FORM_MODEL = {
  email: "",
  permission: "",
};

@Component
export default class Teammates extends Vue {
  form: API_TTeammate = FORM_MODEL;

  permissionTypes = PERMISSION_TYPES;

  loading = false;

  mounted() {
    this.form.permission = MEMBER_VALUE;
  }

  async sendInvitation() {
    let type: string;
    let title: string;
    let message: string;

    try {
      this.loading = true;

      this.form.email = this.form.email.trim();

      await this.axios.post(API_ROUTES.COMPANY_INVITE, this.form);

      type = SUCCESS_NOTIFICATION_TYPE;
      title = this.$tc("notification.inviteEmailIsSent");
      message = `${this.form.email} ${this.$tc("notification.hasBeenInvited")}`;

      this.$emit("update");
    } catch (err) {
      type = ERROR_NOTIFICATION_TYPE;
      title = this.$tc("notification.error.title");
      message = this.$tc("notification.error.message");
    } finally {
      this.loading = false;

      this.form.email = "";
    }

    this.$root.$emit("show-notification", {
      type,
      title,
      message,
    });
  }

  get emailValid() {
    if (!this.form.email) return true;

    return REs.email.test(this.form.email);
  }

  get email() {
    return new CFormField("Email").addRule(() => this.emailValid || this.$tc("error.emailError"));
  }

  get sendInvitationEnable() {
    const { form, loading, emailValid } = this;

    return !someValueInFormIsEmpty(form, []) && !loading && emailValid && form.permission;
  }

  get disabled() {
    return !this.sendInvitationEnable;
  }
}
